
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTimeMore as ObiTimeMoreElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-time-more.js';
 
 
 

 
 export const ObiTimeMore = createComponent({
   react: React,
   tagName: 'obi-time-more',
   elementClass: ObiTimeMoreElement,
   events: {
     
   }
  });
 
 